// @ts-nocheck
/// <reference path="../../../microsoftmaps/microsoft.maps.all.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import uniq from 'lodash/uniq';
import * as MapCallouts from './../components/childcomponents/BingMapCallouts';
import { RCUtils } from './../RCUtils';
import { ReeferStatusGrid } from '../components/childcomponents/ReeferStatusGrid';
import { ReeferMap } from '../components/childcomponents/ReeferMap';
import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
import * as RCNGWindow from '../components/sharedcomponents/ConfirmationWindow';
import { GensetStatusGrid } from '../components/childcomponents/GensetStatusGrid';
//import { DryStatusGrid } from '../components/childcomponents/DryStatusGrid'; 
import { DryStatusSSRMGrid } from '../components/childcomponents/DryStatusSSRMGrid';

import { ChassisStatusGrid } from '../components/childcomponents/ChassisStatusGrid';
import { isNullOrUndefined } from 'util';
import polygonImageblue from '../images/MapPushPins/polygonImage_blue.png';
import pushpingray from '../images/MapPushPins/pushpin_gray.png';
import pushpinyellow from '../images/MapPushPins/pushpin_yellow.png';
import pushpinblue from '../images/MapPushPins/pushpin_blue.png';
import pushpingreen from '../images/MapPushPins/pushpin_green.png';
import pushpinred from '../images/MapPushPins/pushpin_red.png';
import reeferrunning from '../images/MapPushPins/reefer_running.png';
import reeferstandby from '../images/MapPushPins/reefer_standby.png';
import reefershutdown from '../images/MapPushPins/reefer_shutdown.png';
import reeferoffline from '../images/MapPushPins/reefer_offline.png';
import reefernormal from '../images/MapPushPins/reefer_normal.png';
import gensetnormal from '../images/MapPushPins/genset_normal.png';
import drypurple from '../images/MapPushPins/dry_purple.png';
import historynormal from '../images/MapPushPins/history_normal.png';
import chassisorange from '../images/MapPushPins/chassis_orange.png';
import pushpin_green_yellow from '../images/MapPushPins/pushpin_green_yellow.png';
import pushpin_blue_yellow from '../images/MapPushPins/pushpin_blue_yellow.png';
//import { loadBingApi, Microsoft } from "../actions/BingMapLoader";
import { initialize, whenLoaded } from "bing-maps-loader";

var Config: any = require('../Config.json');
var pinInfobox = null;
var toolTip = null;
var reeferMap = null;
var layer = null;
var traceLayer = null;
var fenceLayer = null;
var pinsLayer = null;
var geoZonesLayer = null;
var PushpinsData = [];
var gridName = null;
var calloutState = true;
var GensetPushpinData = [];
var ReeferPushpinData = [];
var DryPushpinData = [];
var ChassisPushpinData = [];
//var checkPinsWithRunState = false;
var fenceAssets = false;

var drawingFinishedEventHandler = null;

var GeofencesData = [];
var drawingTools = null;
//var drawingManager = null;
var currentShape;
var currentMode = null;
var currentFence = null;
var events = [];
var autoSuggestManager = null;
var reeferMasterData = null;
var flag = false;


class ReeferCallout {
    static InitializeMap(params: any) {
        whenLoaded.then(() => {
            reeferMap = new Microsoft.Maps.Map(document.getElementById(params), {
                credentials: Config.BingMapsKey,
                mapTypeId: Microsoft.Maps.MapTypeId.road,
                zoom: 4,
                showMapTypeSelector: true,
                disableKeyboardInput: true,
                liteMode: true
            });

            //var bounds = Microsoft.Maps.LocationRect.fromCorners(new Microsoft.Maps.Location(40.5, -123.5), new Microsoft.Maps.Location(40, -123));
            //var overlay = new PanningOverlay(bounds);
            //reeferMap.layers.insert(overlay);

            //Load the AutoSuggest module.
            Microsoft.Maps.loadModule('Microsoft.Maps.AutoSuggest', function () {
                var options = {
                    maxResults: 4,
                    map: reeferMap,
                    businessSuggestions: true,
                    autoDetectLocation: false
                };
                autoSuggestManager = new Microsoft.Maps.AutosuggestManager(options);
                autoSuggestManager.attachAutosuggest('#txtSearchBox', '#searchBoxContainer', selectedSuggestion);
            });

            //Load the DrawingTools and SpatialMath modules.
            Microsoft.Maps.loadModule(['Microsoft.Maps.DrawingTools', 'Microsoft.Maps.SpatialMath'], function () {

                drawingFinishedEventHandler = Microsoft.Maps.Events.addHandler(reeferMap, 'dblclick', function (args) { drawingFinished(args); });

                //Create an instance of the DrawingTools class and bind it to the map.
                drawingTools = new Microsoft.Maps.DrawingTools(reeferMap);

            });

            Microsoft.Maps.Events.addHandler(reeferMap, 'maptypechanged', function (args) {
                mapTypeChanged(args);
            });

        });
    }

    static pointInPolygon(polygon) {
        var inside = false;
        var center = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);
        //var intersects = Microsoft.Maps.SpatialMath.Geometry.intersects(center, polygon);
        var x = center.latitude, y = center.longitude;

        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            var xi = polygon[i].latitude, yi = polygon[i].longitude;
            var xj = polygon[j].latitude, yj = polygon[j].longitude;

            var intersect = ((yi > y) != (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    }


    static InitializeDrawingManager() {
        if (drawingTools != null && drawingTools != undefined) {
            //Load the DrawingTools and SpatialMath modules.
            Microsoft.Maps.loadModule(['Microsoft.Maps.DrawingTools', 'Microsoft.Maps.SpatialMath'], function () {

                drawingFinishedEventHandler = Microsoft.Maps.Events.addHandler(reeferMap, 'dblclick', function (args) { drawingFinished(args); });

                //Create an instance of the DrawingTools class and bind it to the map.
                drawingTools = new Microsoft.Maps.DrawingTools(reeferMap);

            });
        }        
    }

    static BindGeoZonesLayer() {
        if(geoZonesLayer != null)
            geoZonesLayer.clear();

        var DryAssetsData: any = DryPushpinData;
        if(DryAssetsData.length > 0)
        {
            geoZonesLayer = new Microsoft.Maps.Layer();
            geoZonesLayer.setZIndex(10400);
            
            $.each(DryAssetsData, function (index, value) {
                if(value.Latitude != null && value.Longitude != null && (value.PositionAccuracy !=null && value.PositionAccuracy >0)) {
                    var loc = new Microsoft.Maps.Location(value.Latitude, value.Longitude);
                    var paths = Microsoft.Maps.SpatialMath.getRegularPolygon(loc, value.PositionAccuracy, 36, Microsoft.Maps.SpatialMath.DistanceUnits.Meters);
                    var polygon = new Microsoft.Maps.Polygon(paths, null);

                    geoZonesLayer.add(polygon);
                }
            });            

            reeferMap.layers.insert(geoZonesLayer);
        } 
    }

    static BindGeofencePolygons(fences) {
        if (fenceLayer != null) {
            fenceLayer.clear();
            pinsLayer.clear();
        }
        GeofencesData = fences;

        //Create a layer for the drawn shapes.
        fenceLayer = new Microsoft.Maps.Layer();
        pinsLayer = new Microsoft.Maps.Layer();

        fenceLayer.setZIndex(10200);
        pinsLayer.setZIndex(10300);
        //Clear map infobox
        //if (pinInfobox != null) {
        //    pinInfobox.setOptions({ visible: false });
        //    pinInfobox.setMap(null);
        //}
        clearInfoboxPopup();

        //Create an infobox at the center of the map but don't show it.
        pinInfobox = new Microsoft.Maps.Infobox(reeferMap.getCenter(), {
            visible: false
        });
        //Assign the infobox to a map instance.
        pinInfobox.setMap(reeferMap);

        $.each(fences, function (selectedIndex, selectedValue) {
            var exteriorRing = selectedValue.FormatedCoordinates;
            var selectedFence = selectedValue;
            //var historyId = selectedValue.GeofenceHistoryID;
            var polygon;
            if (selectedValue.GeofenceCategoryCd == "B")
                polygon = new Microsoft.Maps.Polygon(exteriorRing, { strokeDashArray: [1, 3] });
            else
                polygon = new Microsoft.Maps.Polygon(exteriorRing, null);

            fenceLayer.add(polygon);

            var center = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);

            var imageSource = polygonImageblue;
            var pushpinImage = imageSource;
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };

            var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);

            pinsLayer.add(pushpin);

            Microsoft.Maps.Events.addHandler(polygon, 'mousedown', function (args) { displayFenceInfoboxOnClick(args, selectedFence, polygon); });
            Microsoft.Maps.Events.addHandler(pushpin, 'mousedown', function (args) { displayFenceInfoboxOnClick(args, selectedFence, polygon); });

        });

        reeferMap.layers.insert(fenceLayer);
        reeferMap.layers.insert(pinsLayer);
    }

    static CancelDrawing() {
        if (!flag) {
            //fenceLayer.remove(currentShape);
            if (drawingTools != null && drawingTools != undefined) {
                drawingTools.dispose();
                drawingTools = new Microsoft.Maps.DrawingTools(reeferMap);
                currentMode = null;
                currentShape = null;
                clearSelection('DrawingModes', 'btn btn-outline-secondary');
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
            }
        }
    }

    static ContinueDrawing() {
        flag = true;
        currentMode = 'edit';
        document.getElementById("DrawPolygonMode").className = 'btn btn-outline-secondary';
        document.getElementById("EditPolygonMode").className = 'btn btn-outline-secondary active';
        $("#AddGeofenceMode").hide();
        $("#EditGeofenceMode").show();
        $("#DeleteGeofenceMode").hide();
    }
    static resetFlag() {
        flag = false;
    }

    static refreshDashboardMap(geofenceData) {
        addFenceToLayer(geofenceData);
        resetDrawing();
        //ReeferMap.refreshDashBoardMap();
    }

    static SetDrawingMode(mode, elm) {
        clearSelection('DrawingModes', 'btn btn-outline-secondary');
        //elm.className = 'btn btn-secondary editButton active';
        currentFence = null;
        if (mode == "polygon") {
            if (currentMode != mode) {
                document.getElementById("DrawPolygonMode").className = 'btn btn-outline-secondary active';
                $("#AddGeofenceMode").show();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                drawPolygon();
            }
            else {
                document.getElementById("DrawPolygonMode").className = 'btn btn-outline-secondary';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                drawPolygon();
            }
        }
        else if (mode == "edit") {
            if (currentMode != mode) {
                document.getElementById("EditPolygonMode").className = 'btn btn-outline-secondary active';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").show();
                $("#DeleteGeofenceMode").hide();
                edit();
            }
            else {
                document.getElementById("EditPolygonMode").className = 'btn btn-outline-secondary';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                edit();
            }
        }
        else if (mode == "erase") {
            if (currentMode != mode) {
                document.getElementById("DeletePolygonMode").className = 'btn btn-outline-secondary active';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").show();
                erase();
            }
            else {
                document.getElementById("DeletePolygonMode").className = 'btn btn-outline-secondary';
                $("#AddGeofenceMode").hide();
                $("#EditGeofenceMode").hide();
                $("#DeleteGeofenceMode").hide();
                erase();
            }
        }

    }

    static ResetDrawing() {
        resetDrawing();
    }

    static EraseMode() {
        eraseMode();
    }
    
    static DisposeGeozonesLayer() {
        if (geoZonesLayer != null)
            geoZonesLayer.clear();
    }

    static DisposeDrawingManager() {
        if (fenceLayer != null) {
            fenceLayer.clear();
            pinsLayer.clear();

            //if (pinInfobox != null) {
            //    pinInfobox.setOptions({ visible: false });
            //    pinInfobox.setMap(null);
            //}
            clearInfoboxPopup();
        }
        if (drawingTools != null && drawingTools != undefined) {
            drawingTools.dispose();
            //Remove event handlers. 
            Microsoft.Maps.Events.removeHandler(drawingFinishedEventHandler);
            setMode(null);
        }

        if (autoSuggestManager != null && autoSuggestManager != undefined) {
        //    autoSuggestManager.dispose();
            $("#txtSearchBox").val(null);
        }
    }

    static ResetMapPushpins() {
        //if (pinInfobox != null) {
        //    pinInfobox.setOptions({ visible: false });
        //    pinInfobox.setMap(null);
        //}
        clearInfoboxPopup();

        ClearMapLayers();

        calloutState = true;

        ReeferMap.UpdateIsLocationEstimated(false);
        
    }
    static ResetMapInfobox() {
        if (pinInfobox != null) {
            pinInfobox.setOptions({ visible: false });
        }
        calloutState = true;
    }
    static ResetCalloutState() {
        calloutState = true;
    }
    static ResetAllPushpins() {
        GensetPushpinData = [];
        ReeferPushpinData = [];
        DryPushpinData = [];
        ChassisPushpinData = [];
        PushpinsData = [];
    }

    static BindClusterMapAllAssetsPushpins(selectedRows: any, gridType: string, formatterData: any, isFenceAssets: any) {
        
        if (reeferMap != null) {            
            fenceAssets = isFenceAssets;
            reeferMasterData = formatterData;
            if (selectedRows.Dry.length > 0)
                DryPushpinData = selectedRows.Dry;
            if (selectedRows.Genset.length > 0)
                GensetPushpinData = selectedRows.Genset;
            if (selectedRows.Reefers.length > 0)
                ReeferPushpinData = selectedRows.Reefers;
            if (selectedRows.Chassis.length > 0)
                ChassisPushpinData = selectedRows.Chassis;

            PushpinsData = GensetPushpinData.concat(ReeferPushpinData).concat(DryPushpinData).concat(ChassisPushpinData);

            Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', { callback: clusterReeferModuleLoaded });
        }
    }

    static BindClusterMapPushpins(selectedRows: any, gridType: string, formatterData: any) {
        //PushpinsData = [];
        //PushpinsData = selectedRows;
        //gridName = gridType;
        //WI-23853
        GensetPushpinData = [];
        ReeferPushpinData = [];
        DryPushpinData = [];
        ChassisPushpinData = [];

        if (reeferMap != null) {
            reeferMasterData = formatterData;
            if (gridType === 'genset')
                GensetPushpinData = selectedRows;
            else if (gridType === 'status')
                ReeferPushpinData = selectedRows;
            else if (gridType === 'dry')
                DryPushpinData = selectedRows;
            else if (gridType === 'chassis')
                ChassisPushpinData = selectedRows;

            if (GensetPushpinData == null)
                GensetPushpinData = [];
            if (ReeferPushpinData == null)
                ReeferPushpinData = [];
            if (DryPushpinData == null)
                DryPushpinData = [];
            if (ChassisPushpinData == null)
                ChassisPushpinData = [];

            PushpinsData = GensetPushpinData.concat(ReeferPushpinData).concat(DryPushpinData).concat(ChassisPushpinData);

            Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', { callback: clusterReeferModuleLoaded });

            ReeferMap.UpdateIsLocationEstimated(false);
        }
    }
    static BindTracePushpins(selectedRows: any, gridType: string) {
        gridName = gridType;
        PushpinsData = [];
        if (pinInfobox != null) {
            pinInfobox.setOptions({ visible: false });
        }

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
        }

        ClearMapLayers();

        layer = new Microsoft.Maps.Layer();
        //layer.setZIndex(20100);
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.GPSLatitude != null && selectedValue.GPSLongitude != null) {
                var latitude = selectedValue.GPSLatitude;
                var longitude = selectedValue.GPSLongitude;

                var assetId;
                
                var imageSource = '';
                if (selectedValue.GPSLatitude != 0 && selectedValue.GPSLongitude != 0 && ((selectedValue.GPSLockState == null || selectedValue.GPSLockState == "") || selectedValue.GPSLockState.toString().toUpperCase() != "LOCKED"))
                    imageSource = pushpingray;
                else if (selectedIndex == 0) {
                    //imageSource = pushpinyellow;
                    if (selectedValue.EventMasterID.toString() == "52" && selectedValue.DeviceConfig == true)
                        imageSource = pushpin_green_yellow;
                    else if (selectedValue.EventMasterID.toString() == "53" && selectedValue.DeviceConfig == true)
                        imageSource = pushpin_blue_yellow;
                    else
                        imageSource = pushpinyellow;
                }
                //else if (selectedIndex == parseInt(selectedRows.length) - 1)
                //    imageSource = pushpinblue;
                //else if (selectedValue.EventMasterID.toString() == "57" || (selectedValue.DeviceType != null && selectedValue.DeviceType.trim() == "CT3100" && selectedValue.EventMasterID.toString() == "52"))
                //    imageSource = pushpingreen;
                //else if (selectedValue.EventMasterID.toString() == "58" || (selectedValue.DeviceType != null && selectedValue.DeviceType.trim() == "CT3100" && selectedValue.EventMasterID.toString() == "53"))
                //    imageSource = pushpinred;
                else if (selectedValue.EventMasterID.toString() == "52" && selectedValue.DeviceConfig == true)                   
                    imageSource = pushpingreen;
                else if (selectedValue.EventMasterID.toString() == "53" && selectedValue.DeviceConfig == true)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;

                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude); //reeferMap.getCenter();
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);
                if (gridType == "status")
                    assetId = selectedValue.UnitMasterID;
                //pushpin.setOptions({ color: selectedValue.UnitMasterID });
                else
                    assetId = selectedValue.ParentEventID;

                pushpin.metadata = {
                    assetId: assetId
                };
                //pushpin.setOptions({ color: selectedValue.ParentEventID });
                /* InfoBox Code Starts */
                //pushpin.Description = '<div id=' + selectedValue.UnitMasterID + ' style="margin-top:-10px;font-size: xx-small;color: #666;"></div>';
                // Create the infobox for the pushpin
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferMap);
                // Add handler for the pushpin click event.
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayReeferInfobox(args, gridType, assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfoboxOnClick(args, gridName, assetId, false); });
                //Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfobox(args) });
                // Hide the infobox when the map is moved.
                //Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (args) { hideReeferInfobox(args) });
                /* InfoBox Code end     */
                layer.add(pushpin);                
            }
            PushpinsData.push(selectedValue);
        });
        reeferMap.layers.insert(layer);
        reeferMap.setView({ zoom: 12 });
        $('#globalLoader').hide();
        //reeferMap.entities.push(pushpin);
    }
    static DisplaySelectedPushpin(selectedRow: any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }

        calloutState = false;
        if (selectedRow.GPSLatitude != null && selectedRow.GPSLongitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.GPSLatitude;
            var longitude = selectedRow.GPSLongitude;

            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.ParentEventID == selectedRow.ParentEventID) {
                    rowIndex = index;
                    return false;
                }
            });

            var imageSource = '';
            var assetId;
            if (selectedRow.GPSLatitude != 0 && selectedRow.GPSLongitude != 0 && ((selectedRow.GPSLockState == null || selectedRow.GPSLockState == "") || selectedRow.GPSLockState.toString().toUpperCase() != "LOCKED"))
                imageSource = pushpingray;
            else if (rowIndex == 0) {
                //imageSource = pushpinyellow;
                if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
                    imageSource = pushpin_green_yellow;
                else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
                    imageSource = pushpin_blue_yellow;
                else
                    imageSource = pushpinyellow;
            }
            //else if (rowIndex == PushpinsData.length - 1)
            //    imageSource = pushpinblue;
            //else if (selectedRow.EventMasterID.toString() == "57" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "52"))
            //    imageSource = pushpingreen;
            //else if (selectedRow.EventMasterID.toString() == "58" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "53"))
            //    imageSource = pushpinred;
            else if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
                imageSource = pushpingreen;
            else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
                imageSource = pushpinblue;
            else
                imageSource = pushpingray;

            var pushpinImage = imageSource;
            var popOffset = new Microsoft.Maps.Point(-4, 160);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            if (gridName == "status")
                assetId = selectedRow.UnitMasterID;
            //pushpin.setOptions({ color: selectedRow.UnitMasterID });
            else
                assetId = selectedRow.ParentEventID;
            //pushpin.setOptions({ color: selectedRow.ParentEventID });
            pushpin.metadata = {
                assetId: assetId
            };

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';            
            var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode, mapName: gridName, reeferFormatters: reeferMasterData });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferMap.setView({
                center: latLong
            });

            pinInfobox.setMap(reeferMap);

            Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayReeferInfobox(args, gridName, assetId); });
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfoboxOnClick(args, gridName, assetId, false); });

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0
            reeferMap.layers.insert(traceLayer);

        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
           
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';            
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });

            reeferMap.setView({
                center: center
            });

            toolTip.setMap(reeferMap);
          
        }
    }

    //26535 - start
    static DisplaySelectedPushpinByPassingFormatter(selectedRow: any, formatterData: any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }

        calloutState = false;
        if (selectedRow.GPSLatitude != null && selectedRow.GPSLongitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.GPSLatitude;
            var longitude = selectedRow.GPSLongitude;

            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.ParentEventID == selectedRow.ParentEventID) {
                    rowIndex = index;
                    return false;
                }
            });

            var imageSource = '';
            var assetId;
            if (selectedRow.GPSLatitude != 0 && selectedRow.GPSLongitude != 0 && ((selectedRow.GPSLockState == null || selectedRow.GPSLockState == "") || selectedRow.GPSLockState.toString().toUpperCase() != "LOCKED"))
                imageSource = pushpingray;
            else if (rowIndex == 0) {
                //imageSource = pushpinyellow;
                if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
                    imageSource = pushpin_green_yellow;
                else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
                    imageSource = pushpin_blue_yellow;
                else
                    imageSource = pushpinyellow;
            }
            //else if (rowIndex == PushpinsData.length - 1)
            //    imageSource = pushpinblue;
            //else if (selectedRow.EventMasterID.toString() == "57" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "52"))
            //    imageSource = pushpingreen;
            //else if (selectedRow.EventMasterID.toString() == "58" || (selectedRow.DeviceType != null && selectedRow.DeviceType.trim() == "CT3100" && selectedRow.EventMasterID.toString() == "53"))
            //    imageSource = pushpinred;
            else if (selectedRow.EventMasterID.toString() == "52" && selectedRow.DeviceConfig == true)
                imageSource = pushpingreen;
            else if (selectedRow.EventMasterID.toString() == "53" && selectedRow.DeviceConfig == true)
                imageSource = pushpinblue;
            else
                imageSource = pushpingray;

            var pushpinImage = imageSource;
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            if (gridName == "status")
                assetId = selectedRow.UnitMasterID;
            //pushpin.setOptions({ color: selectedRow.UnitMasterID });
            else
                assetId = selectedRow.ParentEventID;
            //pushpin.setOptions({ color: selectedRow.ParentEventID });
            pushpin.metadata = {
                assetId: assetId
            };

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            
            var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode, mapName: gridName, reeferFormatters: formatterData });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferMap.setView({
                center: latLong
            });

            pinInfobox.setMap(reeferMap);

            Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayReeferInfobox(args, gridName, assetId); });
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfoboxOnClick(args, gridName, assetId, false); });

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0
            reeferMap.layers.insert(traceLayer);

        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }

            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });

            reeferMap.setView({
                center: center
            });

            toolTip.setMap(reeferMap);

        }
    }
    //26535 - end
    static BindGensetTracePushpins(selectedRows: any, gridType: string) {
        gridName = gridType;
        PushpinsData = [];
        if (pinInfobox != null) {
            pinInfobox.setOptions({ visible: false });
        }

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
        }

        ClearMapLayers();

        layer = new Microsoft.Maps.Layer();
        //layer.setZIndex(20100);
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.Latitude != null && selectedValue.Longitude != null) {
                var latitude = selectedValue.Latitude;
                var longitude = selectedValue.Longitude;
                //var imageSource = 'genset_normal.png';
                var imageSource = '';
                if (selectedIndex == 0)
                    imageSource = pushpinyellow;
                else if (selectedIndex == parseInt(selectedRows.length) - 1)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;

                var assetId;
                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude); //reeferMap.getCenter();
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);

                //pushpin.setOptions({ color: selectedValue.GensetConditionLogID });
                assetId = selectedValue.GensetHistoryID;
                pushpin.metadata = {
                    assetId: assetId
                };
                /* InfoBox Code Starts */
                //pushpin.Description = '<div id=' + selectedValue.UnitMasterID + ' style="margin-top:-10px;font-size: xx-small;color: #666;"></div>';
                // Create the infobox for the pushpin
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferMap);
                // Add handler for the pushpin click event.
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayGensetInfobox(args, gridType, assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayGensetInfoboxOnClick(args, gridType, assetId, false); });
                //Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfobox(args) });
                // Hide the infobox when the map is moved.
                //Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (args) { hideReeferInfobox(args) });
                /* InfoBox Code end     */
                layer.add(pushpin);                
            }
            PushpinsData.push(selectedValue);
        });
        reeferMap.layers.insert(layer);
        reeferMap.setView({ zoom: 12 });
        $('#globalLoader').hide();
        //reeferMap.entities.push(pushpin);
    }

    static BindDryTracePushpins(selectedRows: any, gridType: string) {
        gridName = gridType;
        PushpinsData = [];
        if (pinInfobox != null) {
            pinInfobox.setOptions({ visible: false });
        }

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
        }

        ClearMapLayers();

        layer = new Microsoft.Maps.Layer();
        //layer.setZIndex(20100);
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.Latitude != null && selectedValue.Longitude != null) {
                var latitude = selectedValue.Latitude;
                var longitude = selectedValue.Longitude;

                //var imageSource = 'purple_pushpin.png';
                var imageSource = '';
                if (selectedIndex == 0)
                    imageSource = pushpinyellow;
                else if (selectedIndex == parseInt(selectedRows.length) - 1)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;

                var assetId;
                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude); //reeferMap.getCenter();
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);

                //pushpin.setOptions({ color: selectedValue.DCConditionLogID });
                assetId = selectedValue.DCHistoryID;
                pushpin.metadata = {
                    assetId: assetId
                };
                /* InfoBox Code Starts */
                //pushpin.Description = '<div id=' + selectedValue.UnitMasterID + ' style="margin-top:-10px;font-size: xx-small;color: #666;"></div>';
                // Create the infobox for the pushpin
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferMap);
                // Add handler for the pushpin click event.
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayDryInfobox(args, gridType, assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayDryInfoboxOnClick(args, gridType, assetId, false); });
                //Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfobox(args) });
                // Hide the infobox when the map is moved.
                //Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (args) { hideReeferInfobox(args) });
                /* InfoBox Code end     */
                layer.add(pushpin);               
            }
            PushpinsData.push(selectedValue);
        });
        reeferMap.layers.insert(layer);
        reeferMap.setView({ zoom: 12 });
        $('#globalLoader').hide();
        //reeferMap.entities.push(pushpin);
    }

    static BindChassisTracePushpins(selectedRows: any, gridType: string) {
        gridName = gridType;
        PushpinsData = [];
        if (pinInfobox != null) {
            pinInfobox.setOptions({ visible: false });
        }

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
        }

        ClearMapLayers();

        layer = new Microsoft.Maps.Layer();
        $.each(selectedRows, function (selectedIndex, selectedValue) {
            if (selectedValue.Latitude != null && selectedValue.Longitude != null) {
                var latitude = selectedValue.Latitude;
                var longitude = selectedValue.Longitude;

                //var imageSource = 'purple_pushpin.png';
                var imageSource = '';                
                if (selectedIndex == 0)
                    imageSource = pushpinyellow;
                else if (selectedIndex == parseInt(selectedRows.length) - 1)
                    imageSource = pushpinblue;
                else
                    imageSource = pushpingray;

                var assetId;
                var pushpinImage = imageSource;
                var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
                var center = new Microsoft.Maps.Location(latitude, longitude); //reeferMap.getCenter();
                var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);

                //pushpin.setOptions({ color: selectedValue.DCConditionLogID });
                assetId = selectedValue.ChassisHistoryID;
                pushpin.metadata = {
                    assetId: assetId
                };
                /* InfoBox Code Starts */
                //pushpin.Description = '<div id=' + selectedValue.UnitMasterID + ' style="margin-top:-10px;font-size: xx-small;color: #666;"></div>';
                // Create the infobox for the pushpin
                pinInfobox = new Microsoft.Maps.Infobox(pushpin.getLocation(), {
                    visible: false
                });
                pinInfobox.setMap(reeferMap);
                // Add handler for the pushpin click event.
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayChassisInfobox(args, gridType, assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayChassisInfoboxOnClick(args, gridType, assetId, false); });
                //Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfobox(args) });
                // Hide the infobox when the map is moved.
                //Microsoft.Maps.Events.addHandler(pushpin, 'mouseout', function (args) { hideReeferInfobox(args) });
                /* InfoBox Code end     */
                layer.add(pushpin);                
            }
            PushpinsData.push(selectedValue);
        });
        reeferMap.layers.insert(layer);
        reeferMap.setView({ zoom: 12 });
        $('#globalLoader').hide();
        //reeferMap.entities.push(pushpin);
    }

    static DisplayGensetSelectedPushpin(selectedRow: any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }

        calloutState = false;
        if (selectedRow.Latitude != null && selectedRow.Longitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.Latitude;
            var longitude = selectedRow.Longitude;

            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.GensetHistoryID == selectedRow.GensetHistoryID) {
                    rowIndex = index;
                    return false;
                }
            });
            //var imageSource = 'genset_normal.png';
            var imageSource = '';
            if (rowIndex == 0)
                imageSource = pushpinyellow;
            else if (rowIndex == PushpinsData.length - 1)
                imageSource = pushpinblue;
            else
                imageSource = pushpingray;

            var assetId;
            var pushpinImage = imageSource;
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            //if (gridName == "status")
            //    pushpin.setOptions({ color: selectedRow.UnitMasterID });
            //else
            //    pushpin.setOptions({ color: selectedRow.ParentEventID });

            //pushpin.setOptions({ color: selectedRow.GensetConditionLogID });
            assetId = selectedRow.GensetHistoryID;

            pushpin.metadata = {
                assetId: assetId
            };

            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferMap.setView({
                center: latLong
            });

            pinInfobox.setMap(reeferMap);

            Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayGensetInfobox(args, gridName, assetId); });
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayGensetInfoboxOnClick(args, gridName, assetId, false); });

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0
            reeferMap.layers.insert(traceLayer);

        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });
            reeferMap.setView({
                center: center
            });
            toolTip.setMap(reeferMap);

        }
    }

    static DisplayDrySelectedPushpin(selectedRow: any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }

        calloutState = false;
        if (selectedRow.Latitude != null && selectedRow.Longitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.Latitude;
            var longitude = selectedRow.Longitude;

            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.DCHistoryID == selectedRow.DCHistoryID) {
                    rowIndex = index;
                    return false;
                }
            });
            //var imageSource = 'purple_pushpin.png';
            var imageSource = '';
            if (rowIndex == 0)
                imageSource = pushpinyellow;
            else if (rowIndex == PushpinsData.length - 1)
                imageSource = pushpinblue;
            else
                imageSource = pushpingray;

            var assetId;
            var pushpinImage = imageSource;
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            //if (gridName == "status")
            //    pushpin.setOptions({ color: selectedRow.UnitMasterID });
            //else
            //    pushpin.setOptions({ color: selectedRow.ParentEventID });

            //pushpin.setOptions({ color: selectedRow.DCConditionLogID });
            assetId = selectedRow.DCHistoryID;
            pushpin.metadata = {
                assetId: assetId
            };
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferMap.setView({
                center: latLong
            });

            pinInfobox.setMap(reeferMap);

            Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayDryInfobox(args, gridName, assetId); });
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayDryInfoboxOnClick(args, gridName, assetId, false); });

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0
            reeferMap.layers.insert(traceLayer);

        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });
            reeferMap.setView({
                center: center
            });
            toolTip.setMap(reeferMap);

        }
    }

    static DisplayChassisSelectedPushpin(selectedRow: any) {
        if (traceLayer != null)
            traceLayer.clear();
        traceLayer = new Microsoft.Maps.Layer();

        if (toolTip != null) {
            toolTip.setOptions({ visible: false });
            toolTip.setMap(null);
        }

        calloutState = false;
        if (selectedRow.Latitude != null && selectedRow.Longitude != null) {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }

            var latitude = selectedRow.Latitude;
            var longitude = selectedRow.Longitude;

            var rowIndex = 0;
            $.each(PushpinsData, function (index, value) {
                if (value.ChassisHistoryID == selectedRow.ChassisHistoryID) {
                    rowIndex = index;
                    return false;
                }
            });
            //var imageSource = 'purple_pushpin.png';
            var imageSource = '';
            if (rowIndex == 0)
                imageSource = pushpinyellow;
            else if (rowIndex == PushpinsData.length - 1)
                imageSource = pushpinblue;
            else
                imageSource = pushpingray;

            var assetId;
            var pushpinImage = imageSource;
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            //var pushpinImage = require(process.env.PUBLIC_URL + '/images/bingcenterSelected_icon.png');
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };
            var latLong = new Microsoft.Maps.Location(latitude, longitude); //reeferHistoryMap.getCenter();
            var pushpin = new Microsoft.Maps.Pushpin(latLong, pushpinOptions);
            //if (gridName == "status")
            //    pushpin.setOptions({ color: selectedRow.UnitMasterID });
            //else
            //    pushpin.setOptions({ color: selectedRow.ParentEventID });

            //pushpin.setOptions({ color: selectedRow.DCConditionLogID });
            assetId = selectedRow.ChassisHistoryID;
            pushpin.metadata = {
                assetId: assetId
            };
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: selectedRow, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox = new Microsoft.Maps.Infobox(latLong, {
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                offset: popOffset,
                showCloseButton: true
            });
            reeferMap.setView({
                center: latLong
            });

            pinInfobox.setMap(reeferMap);

            Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayChassisInfobox(args, gridName, assetId); });
            Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayChassisInfoboxOnClick(args, gridName, assetId, false); });

            traceLayer.add(pushpin, 0); // adding selected row to layer object at index 0
            reeferMap.layers.insert(traceLayer);

        }
        else {
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                //pinInfobox.setMap(null);
            }
            var identityCode = GenerateAlphaNumericCode(6);
            var popOffset = new Microsoft.Maps.Point(-120, 100);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var htmlElement = React.createElement(MapCallouts.PinInfoboxNoLocation, { selectedPin: null, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, htmlElement);
            /* InfoBox Code Ends     */
            var center = reeferMap.getCenter();
            toolTip = new Microsoft.Maps.Infobox(center, {
                htmlContent: description,
                offset: popOffset,
                maxHeight: 50,
                maxWidth: 240
            });
            reeferMap.setView({
                center: center
            });
            toolTip.setMap(reeferMap);

        }
    }
}

function displayGensetInfobox(event, source, assetId) {
    //if (calloutState) {
    //    calloutState = false;
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target.metadata.assetId;
            // var eventId = assetId;
            var dataItem = null;
            if (source == 'status') {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].GensetCurrentConditionId) {
                        if (PushpinsData[i].GensetCurrentConditionId == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].GensetHistoryID) {
                        if (PushpinsData[i].GensetHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
            //if (source) {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //} else {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].GensetConditionLogID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //}
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
    //}
}

function displayGensetInfoboxOnClick(event, source, assetId, enableHistory) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            //var eventId = assetId;
            var eventId = event.target.metadata.assetId;

            var dataItem = null;
            if (source == 'status') {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].GensetCurrentConditionId) {
                        if (PushpinsData[i].GensetCurrentConditionId.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (enableHistory)
                    GensetStatusGrid.SelectCurrentGenset(dataItem);
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].GensetHistoryID) {
                        if (PushpinsData[i].GensetHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }


            //if (source) {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //} else {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].GensetConditionLogID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //}
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.GensetPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function displayDryInfobox(event, source, assetId) {
    //if (calloutState) {
    //    calloutState = false;
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target.metadata.assetId;
            // var eventId = assetId;
            var dataItem = null;
            if (source == "status") {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].DCCurrentConditionID) {
                        if (PushpinsData[i].DCCurrentConditionID == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].DCHistoryID) {
                        if (PushpinsData[i].DCHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
            //if (source) {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //} else {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].GensetConditionLogID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //}
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
    //}
}

function displayDryInfoboxOnClick(event, source, assetId, enableHistory) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            //var eventId = assetId;
            var eventId = event.target.metadata.assetId;
            var dataItem = null;

            if (source == "status") {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].DCCurrentConditionID) {
                        if (PushpinsData[i].DCCurrentConditionID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (enableHistory)
                    DryStatusSSRMGrid.SelectCurrentDry(dataItem);
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].DCHistoryID) {
                        if (PushpinsData[i].DCHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }


            //if (source) {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].CurrentConditionID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //} else {
            //    for (var i = 0; i < PushpinsData.length; i++) {
            //        if (PushpinsData[i].GensetConditionLogID.toString() == eventId) {
            //            dataItem = PushpinsData[i];
            //            break;
            //        }
            //    }
            //}
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.DryPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function displayChassisInfobox(event, source, assetId) {
    //if (calloutState) {
    //    calloutState = false;
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target.metadata.assetId;
            // var eventId = assetId;            
            var dataItem = null;
            if (source == "status") {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ChassisCurrentConditionID) {
                        if (PushpinsData[i].ChassisCurrentConditionID == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ChassisHistoryID) {
                        if (PushpinsData[i].ChassisHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
            
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
    //}
}

function displayChassisInfoboxOnClick(event, source, assetId, enableHistory) {
    if (event.targetType == 'pushpin') {
        try {
            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            //var eventId = assetId;
            var eventId = event.target.metadata.assetId;
            var dataItem = null;            
            if (source == "status") {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ChassisCurrentConditionID) {
                        if (PushpinsData[i].ChassisCurrentConditionID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (enableHistory)
                    ChassisStatusGrid.SelectCurrentChassis(dataItem);
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ChassisHistoryID) {
                        if (PushpinsData[i].ChassisHistoryID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
          
            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.ChassisPinInfoboxDescription, { selectedPin: dataItem, divid: identityCode });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

//class PanningOverlay extends Microsoft.Maps.CustomOverlay {
//    bounds: Microsoft.Maps.LocationRect;
//    private panUpBtn: HTMLInputElement;
//    private panDownBtn: HTMLInputElement;
//    private panLeftBtn: HTMLInputElement;
//    private panRightBtn: HTMLInputElement;

//    constructor(bounds: Microsoft.Maps.LocationRect) {
//        super({ beneathLabels: false });
//        this.bounds = bounds;

//        this.panUpBtn = document.createElement('input');
//        this.panUpBtn.type = 'button';
//        this.panUpBtn.value = '˄';
//        this.panUpBtn.onclick = () => {
//            this.panMap('up');
//        };
//        this.panDownBtn = document.createElement('input');
//        this.panDownBtn.type = 'button';
//        this.panDownBtn.value = '˅';
//        this.panDownBtn.onclick = () => {
//            this.panMap('down');
//        };
//        this.panLeftBtn = document.createElement('input');
//        this.panLeftBtn.type = 'button';
//        this.panLeftBtn.value = '<';
//        this.panLeftBtn.onclick = () => {
//            this.panMap('left');
//        };
//        this.panRightBtn = document.createElement('input');
//        this.panRightBtn.type = 'button';
//        this.panRightBtn.value = '>';
//        this.panRightBtn.onclick = () => {
//            this.panMap('right');
//        };

//    }
//    onAdd() {
//        var container = document.createElement('div');
//        container.appendChild(this.panUpBtn);
//        container.appendChild(this.panDownBtn);
//        container.appendChild(this.panLeftBtn);
//        container.appendChild(this.panRightBtn);
//        container.style.position = 'absolute';
//        container.style.top = '10px';
//        container.style.left = '10px';
//        this.setHtmlElement(container);
//    }
//    panMap(dir: any) {
//        var dx = 0, dy = 0;
//        switch (dir) {
//            case 'up':
//                dy = -30;
//                break;
//            case 'down':
//                dy = 30;
//                break;
//            case 'left':
//                dx = -30;
//                break;
//            case 'right':
//                dx = 30;
//                break;
//        }
//        var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter());
//        cp.x += dx;
//        cp.y += dy;
//        reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp) });
//    }
//}
function clusterReeferModuleLoaded() {
    //Clear map infobox
    //if (pinInfobox != null) {
    //    pinInfobox.setOptions({ visible: false });
    //    pinInfobox.setMap(null);
    //}
    clearInfoboxPopup();

    //Create an infobox at the center of the map but don't show it.
    pinInfobox = new Microsoft.Maps.Infobox(reeferMap.getCenter(), {
        visible: false
    });
    //Assign the infobox to a map instance.
    pinInfobox.setMap(reeferMap);
    ClearMapLayers();

    //checkPinsWithRunState = JSON.parse(sessionStorage.getItem('UserInfo')).ShowMapPinsWithRunState;

    var reeferPushpins = [];
    var firstLatitude;
    var firstLongitude;
    var count = 0;   

    for (var i = 0; i < PushpinsData.length; i++) {
        var assetTypeCd;
        var latitude;
        var longitude;
        var IsReefer = false;
        var IsGenset = false;
        var IsDry = false;
        var IsChassis = false;
        if (PushpinsData[i].GensetCurrentConditionId != undefined) {
            latitude = PushpinsData[i].Latitude;
            longitude = PushpinsData[i].Longitude;
            IsReefer = false;
            IsGenset = true;
            IsDry = false;
            IsChassis = false;
        }
        else if (PushpinsData[i].DCCurrentConditionID != undefined) {
            latitude = PushpinsData[i].Latitude;
            longitude = PushpinsData[i].Longitude;
            IsReefer = false;
            IsGenset = false;
            IsDry = true;
            IsChassis = false;
        }
        else if (PushpinsData[i].ChassisCurrentConditionID != undefined) {
            latitude = PushpinsData[i].Latitude;
            longitude = PushpinsData[i].Longitude;
            IsReefer = false;
            IsGenset = false;
            IsDry = false;
            IsChassis = true;
        } 
        else {
            latitude = PushpinsData[i].GPSLatitude;
            longitude = PushpinsData[i].GPSLongitude;
            IsReefer = true;
            IsGenset = false;
            IsDry = false;
            IsChassis = false;
        }
        //if (gridName == "genset") {
        //    latitude = PushpinsData[i].Latitude;
        //    longitude = PushpinsData[i].Longitude;
        //}
        //else {
        //    latitude = PushpinsData[i].GPSLatitude;
        //    longitude = PushpinsData[i].GPSLongitude;
        //}
        if (latitude != null && longitude != null) {
            var pushpinImage;
            var assetId;
            if (IsReefer) {
                if (!isNullOrUndefined(PushpinsData[i].RunState)) {
                    if ((PushpinsData[i].RunState.toString().toUpperCase().trim()) == 'I')
                        pushpinImage = reeferrunning;
                    else if ((PushpinsData[i].RunState.toString().toUpperCase().trim()) == 'S')
                        pushpinImage = reeferstandby;
                    else if ((PushpinsData[i].RunState.toString().toUpperCase().trim()) == 'X')
                        pushpinImage = reefershutdown;
                    else if ((PushpinsData[i].RunState.toString().toUpperCase().trim()) == 'O')
                        pushpinImage = reeferoffline;
                    else
                        pushpinImage = reefernormal;
                }
                else
                    pushpinImage = reefernormal;
                //if (checkPinsWithRunState) {
                //    if (PushpinsData[i].RunState == 1)
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/ReeferGreen.png';
                //    else if (PushpinsData[i].RunState == 2)
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/ReeferOrange.png';
                //    else if (PushpinsData[i].RunState == 3)
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/ReeferBlue.png';
                //    else if (PushpinsData[i].RunState == 4)
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/ReeferGrey.png';
                //    else if (PushpinsData[i].RunState == 5)
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/ReeferGrey.png';
                //    else
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/reefer_normal.png';
                //}
                //else
                //  pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/reefer_normal.png';

                assetId = PushpinsData[i].UnitMasterID;
                assetTypeCd = "R";
            }
            else if (IsGenset) {
                //if (checkPinsWithRunState) {
                //    if (PushpinsData[i].EventCD != "MSE" && (PushpinsData[i].IgnitionOn != null && PushpinsData[i].IgnitionOn.toString().toUpperCase().trim() == "TRUE"))
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/GensetGreen.png';
                //    else if (PushpinsData[i].EventCD == "MSE" && (PushpinsData[i].IgnitionOn != null && PushpinsData[i].IgnitionOn.toString().toUpperCase().trim() == "TRUE"))
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/GensetOrange.png';
                //    else if (PushpinsData[i].EventCD != "MSE" && (PushpinsData[i].IgnitionOn != null && PushpinsData[i].IgnitionOn.toString().toUpperCase().trim() == "FALSE"))
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/GensetBlue.png';
                //    else if (PushpinsData[i].EventCD == "MSE" && (PushpinsData[i].IgnitionOn != null && PushpinsData[i].IgnitionOn.toString().toUpperCase().trim() == "FALSE"))
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/GensetGrey.png';
                //    else
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/genset_normal.png';
                //}
                //else
                pushpinImage = gensetnormal;

                assetId = PushpinsData[i].GensetCurrentConditionId;
                assetTypeCd = "G";
            }
            else if (IsDry) {
                $('#geoZones').show();
                //if (checkPinsWithRunState) {
                //    if (PushpinsData[i].EventCD != "MSE")
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/DryGreen.png';
                //    else if (PushpinsData[i].EventCD == "MSE")
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/DryBlue.png';
                //    else
                //        pushpinImage = process.env.PUBLIC_URL + '/images/MapPushPins/dry_purple.png';
                //}
                //else
                pushpinImage = drypurple;

                assetId = PushpinsData[i].DCCurrentConditionID;
                assetTypeCd = "D";
            }
            else if (IsChassis) {                
                pushpinImage = chassisorange;

                assetId = PushpinsData[i].ChassisCurrentConditionID;
                assetTypeCd = "C";
            }
            else {
                pushpinImage = historynormal;
                assetId = PushpinsData[i].ParentEventID;
            }
            if (IsReefer && count == 0) {
                firstLatitude = PushpinsData[i].GPSLatitude;
                firstLongitude = PushpinsData[i].GPSLongitude;
            }
            else if (IsGenset && count == 0) {
                firstLatitude = PushpinsData[i].Latitude;
                firstLongitude = PushpinsData[i].Longitude;
            }
            else if (IsDry && count == 0) {
                firstLatitude = PushpinsData[i].Latitude;
                firstLongitude = PushpinsData[i].Longitude;
            }
            else if (IsChassis && count == 0) {
                firstLatitude = PushpinsData[i].Latitude;
                firstLongitude = PushpinsData[i].Longitude;
            }
            //if ((!IsReefer)) {
            //    if (count == 0) {
            //        firstLatitude = PushpinsData[i].Latitude;
            //        firstLongitude = PushpinsData[i].Longitude;
            //    }
            //}
            //else {
            //    if (count == 0) {
            //        firstLatitude = PushpinsData[i].GPSLatitude;
            //        firstLongitude = PushpinsData[i].GPSLongitude;
            //    }
            //}
            //if ((!IsReefer)) {
            //    if (count == 0) {
            //        firstLatitude = PushpinsData[i].Latitude;
            //        firstLongitude = PushpinsData[i].Longitude;
            //    }
            //}
            //else {
            //    if (count == 0) {
            //        firstLatitude = PushpinsData[i].GPSLatitude;
            //        firstLongitude = PushpinsData[i].GPSLongitude;
            //    }
            //}

            count++;
            var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };

            var latLon = new Microsoft.Maps.Location(latitude, longitude);

            var pushpin = new Microsoft.Maps.Pushpin(latLon, pushpinOptions);
            pushpin.metadata = {
                assetId: assetId
            };

            pushpin.setOptions({ color: assetTypeCd });
            if (IsReefer) {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayReeferInfobox(args, 'status', assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayReeferInfoboxOnClick(args, 'status', assetId, true); });

            }
            else if (IsGenset) {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayGensetInfobox(args, 'status', assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayGensetInfoboxOnClick(args, 'status', assetId, true); });

            }
            else if (IsDry) {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayDryInfobox(args, 'status', assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayDryInfoboxOnClick(args, 'status', assetId, true); });

            }
            else if (IsChassis) {
                Microsoft.Maps.Events.addHandler(pushpin, 'mouseover', function (args) { displayChassisInfobox(args, 'status', assetId); });
                Microsoft.Maps.Events.addHandler(pushpin, 'click', function (args) { displayChassisInfoboxOnClick(args, 'status', assetId, true); });

            }


            reeferPushpins.push(pushpin);

        }
    }

    layer = new Microsoft.Maps.ClusterLayer(reeferPushpins, {
        clusteredPinCallback: function (cluster) {
            //Customize clustered pushpin.
            var minRadius = 8;
            var outlineWidth = 1;
            var assetTypes: any = cluster.containedPushpins.map(function (v, i) { return v.getColor() });
            var assetCd = uniq(assetTypes);

            var fillColor;
            if (assetCd.length > 1)
                fillColor = 'rgba(0, 0, 0, 1)';
            else {
                if (assetCd == "R")
                    fillColor = 'rgba(0, 176, 70, 1)';
                else if (assetCd == "G")
                    fillColor = 'rgba(26, 62, 150, 1)';
                else if (assetCd == "C")
                    fillColor = 'rgba(229, 144, 3, 1)';
                else
                    fillColor = 'rgba(128, 0, 128, 1)';
            }

            //if (gridName == "status")
            //    fillColor = 'rgba(0, 176, 70, 1)';//'rgba(0, 0, 0, 1)';
            //else if (gridName == "genset")
            //    fillColor = 'rgba(26, 62, 150, 1)'; 
            //else
            //    fillColor = 'rgba(253, 120, 0, 1)';

            var fillColorDefault = 'rgba(255, 255, 255, 1)';
            //var lstClusterPins = [];

            //var strPinCount = cluster.containedPushpins.length.toString();
            //var strlen = strPinCount.length > 4 ? 4 : strPinCount.length;
            //for (var i = 0; i < cluster.containedPushpins.length; i++) {
            //    var eventId = cluster.containedPushpins[i].getColor();                
            //    var clusterItem = {
            //        EventId: eventId
            //    };
            //    lstClusterPins.push(clusterItem);
            //}
            var clusterSize = cluster.containedPushpins.length;
            var radius = Math.log(clusterSize) / Math.log(10) * 3 + minRadius;

            //Create an SVG string of two circles, one on top of the other, with the specified radius and color.
            var svg = ['<svg xmlns="http://www.w3.org/2000/svg" width="', (radius * 2), '" height="', (radius * 2), '">',
                '<circle cx="', radius, '" cy="', radius, '" r="', radius, '" fill="', fillColorDefault, '"/>',
                '<circle cx="', radius, '" cy="', radius, '" r="', radius - outlineWidth, '" fill="', fillColor, '"/>',
                '</svg>'];
            //Customize the clustered pushpin using the generated SVG and anchor on its center.
            cluster.setOptions({
                icon: svg.join(''),
                anchor: new Microsoft.Maps.Point(radius, radius),
                textOffset: new Microsoft.Maps.Point(0, radius - 8), //Subtract 8 to compensate for height of text.
                //anchor: new Microsoft.Maps.Point(14, 14)
            });
            Microsoft.Maps.Events.addHandler(cluster, 'click', function (args) { clusterPushpinClicked(args); });
            //var clusterlink = "ShowDeviceClusterPinsData('" + JSON.stringify(lstClusterPins) + "')";
            //cluster.Description = "<div style='width:100px;'><a href='#' onclick=" + clusterlink + ">Limit devices…</a></div>";

            //Microsoft.Maps.Events.addHandler(cluster, 'click', function (args) { ReeferClusterPinsDisplayInfobox(args, clusterlink); });
        },
        gridSize: 80,
        zIndex: 20100
    });

    reeferMap.layers.insert(layer);
    if (!fenceAssets) {
        if (firstLatitude != undefined && firstLongitude != undefined) {
            reeferMap.setView({
                center: new Microsoft.Maps.Location(firstLatitude, firstLongitude),
                zoom: 4
            });
        }
    }
}

function clusterPushpinClicked(e) {
    //Check to see if the clicked pushpin has any contained pushpins (this would be a cluster).
    if (e.target.containedPushpins) {
        var locs = [];
        for (var i = 0, len = e.target.containedPushpins.length; i < len; i++) {
            //Get the location of each pushpin.
            locs.push(e.target.containedPushpins[i].getLocation());
        }
        //Create a bounding box for the pushpins.
        var bounds = Microsoft.Maps.LocationRect.fromLocations(locs);
        //Zoom into the bounding box of the cluster. 
        //Add a padding to compensate for the pixel area of the pushpins.
        reeferMap.setView({ bounds: bounds, padding: 100 });
    }
}

function ReeferClusterPinsDisplayInfobox(event, clusterlink) {
    window.event.cancelBubble = true
    if (!event) var e = window.event
    e.cancelBubble = true;
    if (e.stopPropagation)
        e.stopPropagation();

    if (event.targetType == 'pushpin') {
        try {
            var description = "<div style='width:100px;'><a href='#' onclick=" + clusterlink + ">Limit reefers…</a></div>";
            pinInfobox.setOptions({
                location: event.target.getLocation(),
                showPointer: true,
                description: description,
                showCloseButton: true,
                visible: true,
                offset: new Microsoft.Maps.Point(3, 10),
                maxHeight: 50,
                maxWidth: 150
            });

            Microsoft.Maps.Events.addHandler(pinInfobox, 'click', hideReeferInfobox);

        } catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function displayReeferInfoboxOnClick(event, source, assetId, enableHistory) {
    if (event.targetType == 'pushpin') {
        try {      

            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            var eventId = event.target.metadata.assetId;
            //var eventId = assetId;
            var dataItem = null;
            if (source == "status") {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].UnitMasterID) {
                        if (PushpinsData[i].UnitMasterID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
                if (enableHistory)
                    ReeferStatusGrid.SelectCurrentReefer(dataItem);
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ParentEventID) {
                        if (PushpinsData[i].ParentEventID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }

            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';            
            var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: dataItem, divid: identityCode, mapName: gridName, reeferFormatters: reeferMasterData });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}
function displayReeferInfobox(event, source, assetId) {
    //if (calloutState) {
    //    calloutState = false;

    if (event.targetType == 'pushpin') {
        try {           

            if (toolTip != null) {
                toolTip.setOptions({ visible: false });
                toolTip.setMap(null);
            }
            //var index1 = e.target.Description.indexOf("id=") + 3;
            //var index2 = e.target.Description.indexOf("style") - 1;
            //var unitMasterId = e.target.Description.substring(index1, index2);
            // var eventId = assetId;
            var eventId = event.target.metadata.assetId;
            var dataItem = null;
            if (source == "status") {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].UnitMasterID) {
                        if (PushpinsData[i].UnitMasterID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }
            else {
                for (var i = 0; i < PushpinsData.length; i++) {
                    if (PushpinsData[i].ParentEventID) {
                        if (PushpinsData[i].ParentEventID.toString() == eventId) {
                            dataItem = PushpinsData[i];
                            break;
                        }
                    }
                }
            }

            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
            }          
            var popOffset = new Microsoft.Maps.Point(-4, 182);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';            
            var DescElement = React.createElement(MapCallouts.PinInfoboxDescription, { selectedPin: dataItem, divid: identityCode, mapName: gridName, reeferFormatters: reeferMasterData });
            RCUtils.RenderChildComponent(identityCode, DescElement);

            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 200,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: event.target.getLocation(),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            //#### A buffer limit to use to specify the infobox must be away from the edges of the map.
            var buffer = 30;
            var infoboxOffset = pinInfobox.getOffset();
            var infoboxAnchor = pinInfobox.getAnchor();
            var infoboxLocation = reeferMap.tryLocationToPixel(event.target.getLocation(), Microsoft.Maps.PixelReference.control);
            var dx = infoboxLocation.x + infoboxOffset.x - infoboxAnchor.x;
            var dy = infoboxLocation.y - 20 - infoboxAnchor.y;
            if (dy < buffer) {
                //#### Offset in opposite direction.
                dy *= -1;
                //#### add buffer from the top edge of the map.
                dy += buffer;
            }
            else {
                //#### If dy is greater than zero than it does not overlap.
                dy = 0;
            }
            if (dx < buffer) {
                //#### Offset in opposite direction.
                dx *= -1;
                //#### add a buffer from the left edge of the map.
                dx += buffer;
            }
            else {
                dx = reeferMap.getWidth() - infoboxLocation.x + infoboxAnchor.x - pinInfobox.getWidth();
                //#### If dx is greater than zero then it does not overlap.
                if (dx > buffer) {
                    dx = 0;
                }
                else {
                    //#### add a buffer from the right edge of the map.
                    dx -= buffer;
                }
            }
            //#### Adjust the map so infobox is in view
            if (dx != 0 || dy != 0) {
                //map.setView({
                //    centerOffset: new Microsoft.Maps.Point(dx, dy),
                //    center: map.getCenter()
                //});
                var cp = reeferMap.tryLocationToPixel(reeferMap.getCenter(), Microsoft.Maps.PixelReference.control);
                cp.x -= dx;
                cp.y -= dy;
                reeferMap.setView({ center: reeferMap.tryPixelToLocation(cp, Microsoft.Maps.PixelReference.control) });
            }
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
    //}
}


//Removes the selected state for the style options.
function clearSelection(parentId, className) {
    var parent = document.getElementById(parentId);
    for (var i = 0; i < parent.children.length; i++) {
        parent.children[i].className = className;
    }
}

var style = {
    color: 'purple',
    fillColor: 'rgba(0,255,0,0.5)',
    strokeColor: 'blue',
    strokeThickness: 1
};

function addFenceToLayer(fenceData) {
    var coordinatesList = [];
    if (fenceData.Coordinates.length > 0) {
        fenceData.Coordinates.forEach(function (point) {
            var latLong = point.split(",");
            var coordinates = new Microsoft.Maps.Location(latLong[0], latLong[1]);
            coordinatesList.push(coordinates);
        });
    }

    var newFence = { GeofenceHistoryID: null, GeofenceRevisionNum: null, GeofenceCategoryCd: fenceData.FenceTypeCd, Tag: fenceData.FenceId, Name: fenceData.FenceName, Address: fenceData.Address, FormatedCoordinates: coordinatesList };

    GeofencesData.push(newFence);

    if (fenceLayer != null) {
        fenceLayer.clear();
        pinsLayer.clear();
    }
    //fenceLayer = new Microsoft.Maps.Layer();

    //Clear map infobox
    //if (pinInfobox != null) {
    //    pinInfobox.setOptions({ visible: false });
    //    pinInfobox.setMap(null);
    //}
    clearInfoboxPopup();

    //Create an infobox at the center of the map but don't show it.
    pinInfobox = new Microsoft.Maps.Infobox(reeferMap.getCenter(), {
        visible: false
    });
    //Assign the infobox to a map instance.
    pinInfobox.setMap(reeferMap);

    $.each(GeofencesData, function (selectedIndex, selectedValue) {
        var exteriorRing = selectedValue.FormatedCoordinates;
        var selectedFence = selectedValue;

        var polygon;
        if (selectedValue.GeofenceCategoryCd == "B")
            polygon = new Microsoft.Maps.Polygon(exteriorRing, { strokeDashArray: [1, 3] });
        else
            polygon = new Microsoft.Maps.Polygon(exteriorRing, null);
        fenceLayer.add(polygon);

        var center = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);

        var imageSource = polygonImageblue;
        var pushpinImage = imageSource;
        var pushpinOptions = { icon: pushpinImage, height: 31, width: 20, anchor: new Microsoft.Maps.Point(11, 8) };

        var pushpin = new Microsoft.Maps.Pushpin(center, pushpinOptions);

        pinsLayer.add(pushpin);

        Microsoft.Maps.Events.addHandler(polygon, 'mousedown', function (args) { displayFenceInfoboxOnClick(args, selectedFence, polygon); });
        Microsoft.Maps.Events.addHandler(pushpin, 'mousedown', function (args) { displayFenceInfoboxOnClick(args, selectedFence, polygon); });
    });

    reeferMap.layers.insert(fenceLayer);
    reeferMap.layers.insert(pinsLayer);

    $("#globalLoader").hide();
}

function drawPolygon() {
    if (setMode('polygon')) {
        //Create a new polygon.
        drawingTools.create(Microsoft.Maps.DrawingTools.ShapeType.polygon, function (s) {
            s.setOptions(style);
            currentShape = s;
        });
    }
}

function edit() {
    if (setMode('edit')) {
        //Enable pushpin dragging in layer.
        setPushpinDraggability(true);
        events.push(Microsoft.Maps.Events.addHandler(fenceLayer, 'click', function (e) {
            resetDrawingState();
            currentShape = e.primitive;
            //if (e.primitive.metadata && e.primitive.metadata.type === 'circle') {
            //    editCircle(e);
            //} else if (e.primitive.metadata && e.primitive.metadata.type === 'rectangle') {
            //    editRectangle(e);
            //}
            if (e.primitive instanceof Microsoft.Maps.Polygon) {
                //Remove the shape from the map as the drawing tools will display it in the drawing layer.
                fenceLayer.remove(e.primitive);
                //Pass the shape to the drawing tools to be edited.
                drawingTools.edit(e.primitive);
            }
        }));
    } else {
        //Disable pushpin dragging in layer.
        setPushpinDraggability(false);
    }
}

function erase() {
    var IsReprocess = false;
    if (setMode('erase')) {
        events.push(Microsoft.Maps.Events.addHandler(fenceLayer, 'click', function (e) {
            var selectedfence = e.primitive;
            var message = '';
            if (currentFence == null)
                message = 'The geofence will be permanently deleted. Continue?';
            else
                message = "Fence ID '" + currentFence.Tag + "' will be permanently deleted. Continue?";
            RCNGWindow.ConfirmWindow.showConfirmBox(message, function (e) {
                if (!IsReprocess) {
                    if (currentFence == null) {
                        fenceLayer.remove(selectedfence);//remove from layer
                        //resetDrawing();
                        eraseMode();
                    }
                    else {
                        ReeferMap.DeleteCustomerGeofence(currentFence, fenceLayer, selectedfence);
                        //resetDrawing();
                    }
                    IsReprocess = true;
                    RCNGWindow.ConfirmWindow.close();
                }
            }, function (e) {
                RCNGWindow.ConfirmWindow.close();
            });

        }));
        //events.push(Microsoft.Maps.Events.addHandler(fenceLayer, 'mousedown', function (e) { confirmDeleteGeofence(); }));
    }
}

function eraseMode() {
    currentFence = null;
    currentMode = null;
    if (!$("#DeletePolygonMode").hasClass("active")) $('#DeletePolygonMode').addClass('active');
    $("#AddGeofenceMode").hide();
    $("#EditGeofenceMode").hide();
    $("#DeleteGeofenceMode").show();
    erase();
}

function resetDrawing() {
    drawingTools.dispose();
    drawingTools = new Microsoft.Maps.DrawingTools(reeferMap);
    setMode(null);
    $("#AddGeofenceMode").hide();
    $("#EditGeofenceMode").hide();
    $("#DeleteGeofenceMode").hide();
}

function setPushpinDraggability(draggable) {
    var shapes = fenceLayer.getPrimitives();
    for (var i = 0, len = shapes.length; i < len; i++) {
        if (shapes[i] instanceof Microsoft.Maps.Pushpin) {
            shapes[i].setOptions({ draggable: draggable });
        }
    }
}


//Sets the drawing mode, or toggles out of a mode if it is already set. 
//Returns true if the specified mode is new.
function setMode(mode) {
    //Remove all attached events.
    for (var i = 0; i < events.length; i++) {
        Microsoft.Maps.Events.removeHandler(events[i]);
    }
    events = [];
    //Unlock map so incase it has been locked previously.
    //reeferMap.setOptions({ disablePanning: true });
    var state = false;
    if (currentMode === mode || mode == null) {
        //Toggle out of currentMode mode.
        currentMode = null;
        clearSelection('DrawingModes', 'btn btn-outline-secondary');
    } else {
        currentMode = mode;
        state = true;
    }
    resetDrawingState();
    return state;
}

function resetDrawingState() {
    //Stop any current drawing.
    if (currentShape != null && currentShape != undefined) {
        var locs = currentShape.getLocations();
        if (locs.length > 0) {
            drawingTools.finish(function (s) {
                //Add the completed shape to the drawing layer.
                fenceLayer.add(s);
            });
        }
        currentShape = null;
    }
    if (currentMode !== 'edit') {
        //Disable pushpin dragging in layer.
        setPushpinDraggability(false);
    }
}


function mapTypeChanged(params) {
    var mapType = reeferMap.getImageryId();
    if (mapType == "Aerial") {
        $("#mapFences").removeClass('map-Geofence');
        $("#mapFences").addClass('mapGeofenceAerial');
        $("#geoZones").removeClass('map-Geofence');
        $("#geoZones").addClass('mapGeofenceAerial');
        ReeferMap.UpdateFenceImage('A');
    }
    else {
        $("#mapFences").removeClass('mapGeofenceAerial');
        $("#mapFences").addClass('map-Geofence');
        $("#geoZones").removeClass('mapGeofenceAerial');
        $("#geoZones").addClass('map-Geofence');  
        ReeferMap.UpdateFenceImage('R');
    }
}

function validateGeofencePolygon(locs, currentMode, currentFence, GeofencesData) {
    //Api call
    ReeferMap.ValidatePolygonGeofenceDashboard(locs, currentMode, currentFence, GeofencesData);    
}

function drawingFinished(params) {
    if (currentShape != null && currentShape != undefined) {
        var locs = currentShape.getLocations();
        //var dt = Microsoft.Maps.DrawingTools;
        //var da = dt.DrawingMode;
        if (locs != null && locs != undefined) {
            var latlonArray = [];
            $.each(locs, function (index, value) {
                if (!(latlonArray.indexOf(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9)) > -1))
                    latlonArray.push(value.latitude.toFixed(9) + ',' + value.longitude.toFixed(9));
            });
            if (latlonArray.length > 12) {
                PopupWindow.showErrorMessage("Alert", "Maximum of 12 points is allowed.");
            }
            else if (latlonArray.length < 3) {
                PopupWindow.showErrorMessage("Alert", "Minimum of 3 points is required.");
            }
            else 
                validateGeofencePolygon(locs, currentMode, currentFence, GeofencesData);             
        }
    }
}

//function drawingEnded(params) {
//    if (drawingManager != null && drawingManager != undefined) {
//        var dt = Microsoft.Maps.DrawingTools;
//        var da = dt.DrawingMode;
//        var shapes = drawingManager.getPrimitives();
//        if (shapes != null && shapes != undefined && shapes.length > 0) {
//            if (shapes.length > 1) {
//                drawingManager.setDrawingMode(da.erase);
//                alert("Multiple geofences cannot be added.");
//                return false;
//            }
//            var locs = shapes[0].getLocations();
//            if (locs.length > 12) {
//                drawingManager.setDrawingMode(da.edit);
//                alert("A maximum of 12 points is allowed.");
//                return false;
//            }
//            else {               
//                var isPolygon = pointInPolygon(locs);
//                if (isPolygon) {
//                    drawingManager.setDrawingMode(da.none);
//                    //var polygon = new Microsoft.Maps.Polygon(locs);
//                    //Microsoft.Maps.Events.addHandler(polygon, 'click', function () { alert('polygonClick'); });
//                    alert("Popup form to collect geofence information");
//                }
//                else {
//                    alert("A self-intersecting polygon cannot be used to define a geofence. Please change the polygon accordingly.");
//                }
//            }
//        }
//    }
//}

function displayFenceInfoboxOnClick(event, selectedFence, polygon) { 
    currentFence = selectedFence;
    if ((event.targetType == "polygon" || event.targetType == "pushpin") && (currentMode == 'polygon' || currentMode == null)) {
        try {
            var dataItem = null;

            for (var i = 0; i < GeofencesData.length; i++) {
                if (GeofencesData[i].GeofenceHistoryID.toString() == selectedFence.GeofenceHistoryID.toString()) {
                    dataItem = GeofencesData[i];
                    break;
                }
            }

            if (pinInfobox != null) {
                pinInfobox.setOptions({ visible: false });
                pinInfobox.setMap(null);
            }
            var center = Microsoft.Maps.SpatialMath.Geometry.centroid(polygon);
            var popOffset = new Microsoft.Maps.Point(-4, 155);
            var identityCode = GenerateAlphaNumericCode(6);
            /* InfoBox Code Starts     */
            var description = '<div id=' + identityCode + ' class="tab-infobox"></div>';
            var DescElement = React.createElement(MapCallouts.PinInfoboxFenceLocation, { selectedPin: dataItem, divid: identityCode, source: "Dashboard" });
            RCUtils.RenderChildComponent(identityCode, DescElement);
            // Create the infobox for the pushpin
            pinInfobox.setOptions({
                maxHeight: 130,
                maxWidth: 540,
                showPointer: true,
                description: description,
                location: new Microsoft.Maps.Location(center.latitude, center.longitude),
                visible: true, offset: popOffset,
                showCloseButton: true
            });

            var exteriorRing = dataItem.FormatedCoordinates;
            var bound = Microsoft.Maps.LocationRect.fromLocations(exteriorRing);
            reeferMap.setView({ bounds: bound, center: center, padding: 100 });//RCNG-2840

            pinInfobox.setMap(reeferMap);
         
        }
        catch (ex) {
            //alert(ex.message + " " + ex.description);
        }
    }
}

function selectedSuggestion(suggestionResult) {
    reeferMap.entities.clear();

    reeferMap.setView({ bounds: suggestionResult.bestView });
}

function ClearMapLayers() {
    if (layer != null)
        layer.clear();
    if (traceLayer != null)
        traceLayer.clear();
    if(geoZonesLayer != null) {
        ReeferMap.RestoreGeoZonesLayer();
        geoZonesLayer.clear();
    }
    $('#geoZones').hide();
}

function hideReeferInfobox(e) {
    if (pinInfobox != null)
        pinInfobox.setOptions({ visible: false });
}

function GenerateAlphaNumericCode(length) {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
        result = ""
    for (var i = length; i > 0; --i)
        result += chars[Math.round(Math.random() * (chars.length - 1))]
    return result
}

function clearInfoboxPopup() {
    if (pinInfobox != null) {
        pinInfobox.setOptions({ visible: false });
        pinInfobox.setMap(null);
    }
    if (toolTip != null) {
        toolTip.setOptions({ visible: false });
        toolTip.setMap(null);
    }
}

export default ReeferCallout;
